module.exports = __webpack_public_path__ + "img/选中背景.61facc08.png";